import { Head } from "@inertiajs/react";
import { ReactNode } from "react";
import classNames from "classnames";

interface Props {
  title: string;
  /** Room for a side rail next to the main column (Home). */
  wide?: boolean;
  children: ReactNode;
}

export default function UserPageShell({ title, wide = false, children }: Props) {
  return (
    <>
      <Head title={title} />
      <div
        className={classNames(
          "mx-auto flex flex-col gap-8 px-4 py-5 sm:gap-10 sm:px-6 sm:py-8",
          wide ? "max-w-[1160px]" : "max-w-[900px]",
        )}
      >
        {children}
      </div>
    </>
  );
}
